class PQEvent {
  static OPEN = 'PQEvent.open';

  static CLOSE = 'PQEvent.close';

  static RENAME = 'PQEvent.rename';
}

export default PQEvent;
